import { render, staticRenderFns } from "./BlogArticleContent.vue?vue&type=template&id=210a3fc8&"
import script from "./BlogArticleContent.vue?vue&type=script&lang=js&"
export * from "./BlogArticleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports